// ─── Validate persistence (localStorage) ───────────────────────────────────────
// Stores QA/QC marks, mark-rules, comments and a version-history log so they
// survive a page reload. Per-browser (no backend); a server-side/shared store
// would need DB tables + endpoints.
// ──────────────────────────────────────────────────────────────────────────────

const KEY = 'wqdata_validate_v1'
const EMPTY = { marks: {}, rules: [], comments: [], history: [] }

export function loadValidate() {
  try {
    return { ...EMPTY, ...(JSON.parse(localStorage.getItem(KEY)) || {}) }
  } catch { return { ...EMPTY } }
}

export function saveValidate(state) {
  try { localStorage.setItem(KEY, JSON.stringify(state)) } catch { /* quota */ }
}

export const markKey = (paramId, label) => `${paramId}|${label}`

// Order + labels match the XD "Find and Mark" / "Mark Rules" spec.
export const CONDITIONS = [
  { id: 'gt', label: 'Greater Than' },
  { id: 'gte', label: 'Greater Than or Equal To' },
  { id: 'lt', label: 'Less Than' },
  { id: 'lte', label: 'Less Than or Equal To' },
  { id: 'eq', label: 'Is Equal To' },
  { id: 'neq', label: 'Is Not Equal To' },
  { id: 'between', label: 'Is Between', two: true },
  { id: 'notbetween', label: 'Is Not Between', two: true },
]

export function matchCondition(value, cond, v1, v2) {
  const x = Number(value)
  if (Number.isNaN(x)) return false
  const a = Number(v1), b = Number(v2)
  const inRange = x >= Math.min(a, b) && x <= Math.max(a, b)
  switch (cond) {
    case 'gt': return x > a
    case 'gte': return x >= a
    case 'lt': return x < a
    case 'lte': return x <= a
    case 'eq': return x === a
    case 'neq': return x !== a
    case 'between': return inRange
    case 'notbetween': return !inRange
    default: return false
  }
}

// monotonic-ish id without Date.now (kept simple + unique enough per session)
let _seq = 0
export function uid(prefix = 'id') { _seq += 1; return `${prefix}_${_seq}_${Math.floor(performance.now())}` }
